module.exports = __webpack_public_path__ + "img/logo-for-webpage-nav-bar.c55340b5.svg";